<template>
  <div>
    <div>
      <b-row align-v="center" align-h="between">
        <b-col>
          <div class="d-flex justify-content-end">
            <div class="alert d-flex align-items-right bg-primary">
              <span class="text-white font-size-sm font-weight-bold m-0">
                تعداد سیستم عامل ها:

                {{ numberFormat(adminFirmwaresPagination.total) }}
              </span>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

    <div>
      <div v-if="loaded && adminFirmwares.length === 0">
        <div class="alert alert-primary" role="alert">سیستم عامل یافت نشد.</div>
      </div>
    </div>
    <div
      v-if="loaded && adminFirmwares.length"
      class="card card-custom gutter-b"
    >
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>ورژن</th>
                <th>فایل</th>
                <th>نوع</th>
                <th>عملیات ها</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="firmware in adminFirmwares" :key="firmware.id">
                <td dir="ltr">
                  {{ firmware.version }}
                </td>
                <td dir="ltr" class="text-nowrap">
                  <a :href="firmware.url" :download="firmware.file">
                    {{ firmware.file }}
                  </a>
                </td>
                <td dir="ltr" class="text-nowrap">
                  {{ firmware.type }}
                </td>
                <td class="text-nowrap"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div
      class="overflow-auto mt-5"
      v-if="adminFirmwaresPagination.lastPage > 1"
    >
      <b-pagination
        v-model="adminFirmwaresPagination.currentPage"
        :total-rows="adminFirmwaresPagination.total"
        :per-page="adminFirmwaresPagination.perPage"
        aria-controls="my-table"
        @input="updateDevices()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { FETCH_ADMIN_FIRMWARES } from "@/core/services/store/admin/firmwares.module";
import { mapGetters } from "vuex";

export default {
  name: "firmwares",
  data() {
    return {
      loaded: false,
      searchDevice: "",
      search: {
        cellphone: "",
        company: null
      }
    };
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "مدیریت",
        route: { name: "admin-dashboard" }
      },
      { title: "سیستم عامل ها" }
    ]);
    this.$store.dispatch(SET_ACTIONS, {
      links: [
        {
          name: '<i class="flaticon2-plus"></i>افزودن',
          to: { name: "admin-firmwares-create" },
          class: "btn-primary"
        }
      ]
    });

    this.updateDevices();
  },
  computed: {
    ...mapGetters(["adminFirmwares", "adminFirmwaresPagination"])
  },
  methods: {
    updateDevices() {
      this.loaded = false;
      this.$store
        .dispatch(FETCH_ADMIN_FIRMWARES, {})
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    }
  }
};
</script>
